import { getFromSessionStorage } from 'common/utils/app.utils';
import { AUTHORIZATION_HEADER, MODULE_ID, PNQ_AUTHORIZATION_HEADER } from 'home/common/constants/constants';
import React, { useEffect, useState } from 'react';
import Drawer from '../../../../common/components/drawer_modal/drawer_modal';
import { validateFileAndGetFormData } from '../../../../common/utils/validator';
import DownloadExcel from '../../downloadExcel/downloadExcel';
import UploadExcel from '../../uploadExcel/uploadExcel';
import { AUTH_TOKEN, CART_ID, DEFAULT_TOAST_MSG, MULTI_SITE_MODULE_ID, SESSION_LEAD_ID } from 'home/view/manage-feasibility/constants';
import {
  CUSTOMER_MESSAGE,
  FILE_UPLOAD_ACTIONS,
  isUserTypeIsKAM,
  TOAST_TYPE,
  DEFAULT_FILE_PROPS,
  KAM_META_DATA,
  DOA_STATUS,
  DEFAULT_FILE_NAME
} from '../configure-plan-pricing-constant';
import FileSaver from 'file-saver';
import { downloadErrorSheets, downloadExcel, uploadExcel } from '../configure-plan-pricing.service';
import ToastComponent from 'common/components/toast/toast.component';
import { Notification } from 'featureLib/NotificationComponent';
import { getFileName } from 'home/view/manage-feasibility/utils';
import { getDownloadModalText } from 'home/view/check-feasibility/comp-generator/component.generator';
import { getNotificationType } from 'common/utils/app.utils';

const FileUpload = ({ setIsOpen, uploadCallBack, isSaved, setSaveButtonDisable, setToast, setIsUploading }) => {
  const [formData, setFormData] = useState({});
  const [files, setFiles] = useState({});
  const [toast, setToastForComponent] = useState({
    show: false,
    message: '',
    type: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const fileSchema = {
    supportedTypes: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'],
    maxFileLimit: 1024 * 1024,
    documentNames: ['file', 'file2'],
    documentType: 'file'
  };
  const onFileChange = (files) => {
    if (!files) {
      setFileUploadProps({
        ...fileUploadProps,
        value: []
      });
      setSaveButtonDisable(true);
      return false;
    }
    const { isFilesValid, errorMessage } = validateFileAndGetFormData({
      event: { target: { files }, stopPropagation: () => {} },
      ...fileSchema
    });
    if (isFilesValid) {
      setSaveButtonDisable(false);
      const KAMInfo = getFromSessionStorage(MULTI_SITE_MODULE_ID, KAM_META_DATA);
      const { doaStatus } = KAMInfo ? KAMInfo : {};
      setFiles(files);
      setFormData(getFormData(files[0], doaStatus));
      setFileUploadProps({
        ...fileUploadProps,
        helpTexts: [],
        renderUploadedFiles: displayUploadedFiles(Array.from(files)),
        key: Date.now()
      });
    } else {
      setSaveButtonDisable(true);
      setFileUploadProps({
        ...fileUploadProps,
        helpTexts: [],
        required: false,
        errors: [<p style={{ color: '#ED4F42' }}> {errorMessage} </p>],
        errorClass: 'errorMsg',
        showAllErrors: true,
        touched: true,
        key: Date.now()
      });
      setToastForComponent({
        show: true,
        message: errorMessage,
        type: TOAST_TYPE.ERROR
      });
    }
  };

  const downloadFile = (name, file) => {
    FileSaver.saveAs(file, name);
  };

  const removeFiles = (fileName, fileList = []) => {
    const updatedFileList = fileList.filter(({ name }) => name !== fileName);
    if (updatedFileList.length === 0) {
      setSaveButtonDisable(true);
      setFileUploadProps({
        ...DEFAULT_FILE_PROPS,
        onChange: onFileChange
      });
      return false;
    }
    setFileUploadProps((props) => ({
      ...props,
      renderUploadedFiles: displayUploadedFiles(updatedFileList)
    }));
  };

  const displayUploadedFiles = (files) => {
    if (Array.isArray(files)) {
      return files.map((file, index) => {
        const { name, size, type } = file;
        return (
          <div key={index + name}>
            <span onClick={downloadFile.bind(null, name, file)} className="fileName" title={name}>
              {name}
            </span>
            <span className="cross_icon" onClick={removeFiles.bind(null, name, files)}></span>
          </div>
        );
      });
    }
  };

  const uploadFile = (formData, files) => {
    const config = {
      headers: {
        Authorization: isUserTypeIsKAM() ? getFromSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER) : getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER)
      },
      config: {
        ignoreError: true,
        dedicatedJourney: true
      }
    };
    const { name } = files[0];
    setIsUploading(true);

    return uploadExcel(formData, config)
      .then(({ data: { success, result, message } }) => {
        console.log(success, result);
        setIsUploading(false);
        if (success) {
          setFileUploadProps({ ...fileUploadProps, label: '', value: [] });
          setIsOpen(false);
          uploadCallBack && uploadCallBack(name);
        } else {
          console.log('download error file');
          const toastErrorMessage = (
            <span>
              Errors found in the file.{' '}
              <span
                style={{
                  textDecoration: 'underline',
                  cursor: 'pointer'
                }}
                role="button"
                tabIndex="0"
                onClick={() => downloadErrorFile(result)}
              >
                Download error file
              </span>
            </span>
          );
          const errorMessage = (
            <span style={{ color: '#ED4F42' }}>
              Errors found in the file.{' '}
              <span
                style={{
                  color: '#cc000a',

                  textDecoration: 'underline',

                  cursor: 'pointer'
                }}
                role="button"
                tabIndex="0"
                onClick={() => downloadErrorFile(result)}
              >
                Download error file
              </span>
            </span>
          );
          setFileUploadProps({
            ...fileUploadProps,
            helpTexts: [],
            required: false,
            errors: [errorMessage],
            errorClass: 'errorMsg',
            showAllErrors: true,
            touched: true,
            key: Date.now(),
            renderUploadedFiles: []
          });
          setToastForComponent({
            show: true,
            message: toastErrorMessage,
            type: TOAST_TYPE.ERROR
          });
        }
      })
      .catch((err) => {
        const {
          response: { data }
        } = err;
        setFileUploadProps({
          ...fileUploadProps,
          key: Date.now()
        });
        setIsUploading(false);
        setToastForComponent({
          show: true,
          message: data && data.errorMsg ? data.errorMsg : 'Something went wrong',
          type: TOAST_TYPE.ERROR
        });
      });
  };

  const downloadErrorFile = async ({ leadId, errorSheetUrl }) => {
    const authorisationToken = isUserTypeIsKAM() ? getFromSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER) : getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER);
    const { res, err } = await downloadErrorSheets(errorSheetUrl, authorisationToken, leadId);
    if (res) {
      const { data = {} } = res;
      const fileName = getFileName(res, `Error${DEFAULT_FILE_NAME}`);
      const file = new Blob([data]);
      FileSaver.saveAs(file, fileName);
    } else if (err) {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

      setToast(true, errorMsg, TOAST_TYPE.ERROR);
    }
  };

  const getFormData = (file, doaStatus) => {
    console.log(doaStatus);
    const action = doaStatus === DOA_STATUS.CLARITY_REQUIRED ? FILE_UPLOAD_ACTIONS.PRICE_CONFIGURATION : FILE_UPLOAD_ACTIONS.PLAN_CONFIGURATION;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('action', action);
    formData.append('cartId', getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_ID));
    return formData;
  };

  const [fileUploadProps, setFileUploadProps] = useState({
    ...DEFAULT_FILE_PROPS,
    onChange: onFileChange
  });

  useEffect(() => {
    if (isSaved) {
      uploadFile(formData, files);
    }
  }, [isSaved]);

  const onDownloadExcel = () => {
    const config = {
      params: {
        cartId: getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_ID),
        action: FILE_UPLOAD_ACTIONS.PLAN_CONFIGURATION
      },
      headers: {
        Authorization: isUserTypeIsKAM() ? getFromSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER) : getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER)
      },
      responseType: 'blob'
    };
    setIsLoading(true);
    return downloadExcel(config)
      .then((response) => {
        const { data } = response;
        setIsLoading(false);
        const fileName = getFileName(response, DEFAULT_FILE_NAME);
        const file = new Blob([data]);
        FileSaver.saveAs(file, fileName);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const toggelToastPopup = () => {
    setToastForComponent({ show: false, message: '', type: '' });
  };

  return (
    <React.Fragment>
      {/* {toast.show && <ToastComponent topPosition={0} closeNetworkCoveragePopup={toggelToastPopup} toastMessage={toast.message} successToast={toast.type} closeToastTime={'8000'} />} */}
      <section id="notification">
        <Notification show={toast.show} type={getNotificationType(toast.type)} message={toast.message} eventHandler={toggelToastPopup} onCancel={toggelToastPopup}></Notification>
      </section>
      <div className="configration_area">
        <DownloadExcel
          title={'Export Excel Configuration File'}
          body={getDownloadModalText(true)}
          isLoading={isLoading}
          buttonText={'Download Excel for Configuration'}
          onClick={onDownloadExcel}
        />
      </div>
      <div className="upload_docs_area">
        <UploadExcel
          title={'Upload Excel Configuration File'}
          body={'Upload the configured Excel file of feasible sites here. Please note all changes as per the uploaded file will be revised and updated on the system.'}
          fileUploadProps={fileUploadProps}
        ></UploadExcel>
      </div>
    </React.Fragment>
  );
};

export const ConfigureSiteWithExcel = ({ isOpen, setIsOpen, uploadCallBack, setToast }) => {
  const [isSaved, setIsSaved] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const onSave = () => {
    setIsSaved(new Boolean(true));
  };

  return (
    <React.Fragment>
      <Drawer
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        headingTitle={'Configure Sites with Excel'}
        drawerContent={
          <FileUpload
            setToast={setToast}
            setIsOpen={setIsOpen}
            uploadCallBack={uploadCallBack}
            isSaved={isSaved}
            setSaveButtonDisable={setIsDisable}
            setIsUploading={setIsLoading}
          ></FileUpload>
        }
        showOnlyClose={false}
        onSave={onSave}
        disabled={isDisable}
        isLoading={isLoading}
      />
    </React.Fragment>
  );
};
